<template>
    <FormModal :model="model" :init="init" modal-id="user">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label="権限"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-radio-group v-model="model.level" size="sm">
                        <b-form-radio value="000">なし</b-form-radio>
                        <b-form-radio value="100">一般</b-form-radio>
                        <b-form-radio value="200">編集者</b-form-radio>
                        <b-form-radio value="300">管理者</b-form-radio>
                    </b-form-radio-group>
                    <input-error :errors="error.level" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="姓 名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <b-form-input
                                v-model="model.last_name"
                                size="sm"
                                placeholder="山田"
                                ></b-form-input>
                            <input-error :errors="error.last_name" />
                        </b-col>
                        <b-col>
                            <b-form-input
                                v-model="model.first_name"
                                size="sm"
                                placeholder="太郎"
                                ></b-form-input>
                            <input-error :errors="error.first_name" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="せい めい"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <b-form-input
                                v-model="model.last_kana"
                                size="sm"
                                placeholder="やまだ"
                                ></b-form-input>
                            <input-error :errors="error.last_kana" />
                        </b-col>
                        <b-col>
                            <b-form-input
                                v-model="model.first_kana"
                                size="sm"
                                placeholder="たろう"
                                ></b-form-input>
                            <input-error :errors="error.first_kana" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="表示名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.nickname"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.nickname" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="メール"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.email"
                        size="sm"
                        placeholder="email@example.com"
                        ></b-form-input>
                    <small class="text-muted">Gmail登録済みメールアドレス</small>
                    <input-error :errors="error.email" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="特定商取引法、プライバシーポリシー"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <BaseEditor
                        v-model="model.policy"
                        />
                    <input-error :errors="error.policy" />
                </b-form-group>
            </template>
            <template v-else>
                <div class="mb-3">
                    <p class="mb-1">
                        <b-badge
                            :variant="$store.getters['user/level2variant'](model.level)"
                            >
                            {{
                            trans.labels[
                            'users.level.' + model.level
                            ]
                            }}
                        </b-badge>
                    </p>
                
                    <b-form-group
                        label-cols-sm="2"
                        label="姓 名"
                        label-size="sm"
                        >
                        <ruby v-if="model.last_name">
                            {{ model.last_name }}
                            <rt v-if="model.last_kana">
                            {{ model.last_kana }}
                            </rt>
                        </ruby>
                        <ruby v-if="model.first_name">
                            {{ model.first_name }}
                            <rt v-if="model.first_kana">
                            {{ model.first_kana }}
                            </rt>
                        </ruby>
                    </b-form-group>
                    <b-form-group
                        label-cols-sm="2"
                        label="表示名"
                        label-size="sm"
                        >
                        {{ model.nickname }}
                    </b-form-group>
                    <b-form-group
                        label-cols-sm="2"
                        label="メール"
                        label-size="sm"
                        >
                        <a :href="'mailto:' + model.email">{{ model.email }}</a>
                    </b-form-group>
                    <b-form-group
                        label-cols-sm="2"
                        label="アカウントURL"
                        label-size="sm"
                        >
                        <a :href="'/f/' + model.uuid" target="_blank">/f/{{ model.uuid }}</a>
                    </b-form-group>
                    <b-form-group
                        label-cols-sm="2"
                        label="特定商取引法、プライバシーポリシー"
                        label-size="sm"
                        >
                        <BaseEditor
                            v-model="model.policy"
                            :editable="false"
                            />
                    </b-form-group>
                </div>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'

export default {
    components: {
        FormModal,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped></style>


